<template>
  <div>
    <!-- eslint-disable-next-line -->
    <div v-for="snackbar in snackbars">
      <v-snackbar
        :bottom="snackbar.position.includes('bottom')"
        :color="snackbar.color"
        :left="snackbar.position.includes('left')"
        :right="snackbar.position.includes('right')"
        :timeout="snackbar.timeout"
        :top="snackbar.position.includes('top')"
        :vertical="true"
        multi-line
        v-model="snackbar.show"
      >
        {{ snackbar.text }}
        <v-btn @click="snackbar.show = false" dark text>
          OK
        </v-btn>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
export default {
  name: "Snackbar",
  data() {
    return {};
  },
  computed: {
    snackbars() {
      return this.$store.getters["snackbars"];
    }
  }
};
</script>

<style scoped></style>
